var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"section-heading"},[_c('div',[_c('span',{staticClass:"notch notch--dark notch--lg notch--bm"}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),(_vm.body)?_c('p',[_vm._v(_vm._s(_vm.body))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-604bb2ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionIntro.vue
// module id = 81
// module chunks = 0